export enum TravelLicenseSubscriptionOptions {
  AutoRenewal = 'autoRenewal',
}
